import styled from 'styled-components';
import SimpleBarReact from 'simplebar-react';

interface TableProps {
  columns: string[];
  rows: (string | number)[][];
  keyExtension: string;
}
const alphabetList = [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'];

export const Table: React.FC<TableProps> = ({
  columns,
  rows,
  keyExtension,
}) => {
  const filteredEmptyRows = rows.filter((row) => row.length !== 0);

  return (
    <TableContainer>
      <StyledTable>
        <TableHead>
          <TableRow>
            {columns.map((col) => (
              <TableCell key={`header-${col}`}>{col}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <tbody>
          {filteredEmptyRows.map((row, rowIdx) => (
            <TableRow key={`${keyExtension}-${row[0]}`}>
              {row.map((cell, cellIdx) => (
                <TableCell
                  key={`cell-${keyExtension}-${cell}-${Math.random() * 20}`}
                >
                  {cellIdx === 0 && alphabetList[rowIdx] + ' '}
                  {cell}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </tbody>
      </StyledTable>
    </TableContainer>
  );
};

export const TableContainer = styled.div`
  box-shadow: none;
  width: unset;
  margin: 0 1rem;
  color: ${({ theme }) => theme.colors.text};
  background-color: transparent;
  border-bottom: 0;
  overflow-x: auto;
  margin-bottom: 1.5rem;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
`;

export const TableRow = styled.tr`
  color: inherit;
  outline: 0;
  vertical-align: middle;

  & th {
    font-weight: 300;
  }

  & :first-child {
    min-width: 19rem;
    font-weight: 400;

    @media ${({ theme }) => theme.breakpoints.md} {
      width: 14.125rem;
    }
  }
`;

export const TableHead = styled.thead`
  & > tr > th {
    font-weight: 400;

    @media ${({ theme }) => theme.breakpoints.md} {
      font-size: 0.75rem;
    }
  }

  border-bottom: 1px solid ${({ theme }) => theme.colors.text};
`;

export const TableCell = styled.th`
  padding: 0.75rem;
  font-size: 1rem;
  text-align: left;
  vertical-align: inherit;
  font-weight: 500;
  letter-spacing: 0.01071em;
  line-height: 1.43;
  min-width: 6.25rem;

  @media ${({ theme }) => theme.breakpoints.md} {
    min-width: 4.5rem;
    font-size: 0.75rem;
  }
`;

const StyledSimpleBarReact = styled(SimpleBarReact)`
  .simplebar-placeholder {
    display: none;
  }
  .simplebar-scrollbar {
    width: 0.375rem;
    height: 0.625rem;
    background: ${({ theme }) => theme.colors.borderGrey};
    border-radius: 0.625rem;
    :hover {
      background: ${({ theme }) => theme.colors.scrollHover};
    }
  }
`;
